import { jsx } from "react/jsx-runtime";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "../Dialog";
import Drawer from "../Drawer";
import { useTheme } from "../ThemeProvider";
const Popup = (props) => {
  const {
    forceMobile,
    controls,
    mobileControls,
    mobileBreakpoint,
    children
  } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint ?? "md"));
  if (isMobile || forceMobile)
    return /* @__PURE__ */ jsx(Drawer, { ...props, controls: mobileControls || controls, children });
  return /* @__PURE__ */ jsx(Dialog, { ...props, controls, children });
};
var Popup_default = Popup;
export {
  Popup_default as default
};
